import ResetPasswordResult from "./ResetPasswordResult";

export default ResetPasswordResult;
